import React from "react";
import Style from "./StoreMenuProdct.module.css";
import NumberOfOrder from "../NumberOfOrder/NumberOfOrder";
import { separate } from "../../Seprate/Seprate";
import { Link } from "react-router-dom";

const StoreMenuProduct = ({forceUpdate,supllierDetail}) => {
  const updateState = () => {
    forceUpdate();
  };
  return ( 
    <div className={Style.FoodInfo}>
      {supllierDetail?.categories?.map((item) => {
        return (
          <div className={Style.ListHolder} key={item.id}>
            <h3 className={Style.FoodKind} id={`category${item.id}`}>
              {" "}
              {item.category}{" "}
            </h3>
            <ul className={Style.FoodList}>
              {
              item.products&&item.products.map((food) => {
                return (
                  food.count==="0"?null:
                  <li key={food.id} className={Style.FoodHolder}>
                    <div className={Style.FoodHolderTopDiv}>
                      <div className={Style.FoodHolderTopRightDiv}>
                        <h3>{food.name}</h3>
                        <p>{food.other_detail}</p>
                      </div>
                      <div className={Style.FoodHolderTopLeftDiv}>
                        <img
                          src={`//cdn.barest.ir/product/m/${food.id}.jpg`}
                          alt={food.name}
                        />
                        <Link to={`/product/${food.id}/${supllierDetail?.supplier?.id}/`} className={Style.detailFood}>جزییات محصول</Link>
                      </div>
                    </div>
                    <div className={Style.FoodHolderBottomDiv}>
                      <div className={Style.FoodHolderBottomRightDiv}>
                        {food.off_price > 0 ? (
                          <p>
                            تومان<span>{separate(food.off_price)}</span>{" "}
                            <span className={Style.discountprice}>
                              {separate(food.price)}
                            </span>
                          </p>
                        ) : (
                          <p>
                            تومان<span>{separate(food.price)}</span>
                          </p>
                        )}
                      </div>
                      <div className={Style.FoodHolderBottomLeftDiv}>
                        {supllierDetail?.supplier?.supplier_working_hours?.open==="0"?null:<NumberOfOrder
                          dataUpdate={updateState}
                          supId={supllierDetail?.supplier?.id}
                          data={food}
                        />}
                        
                      </div>
                    </div>
                  </li>
                );
              })
              }
            </ul>
          </div>
        );
      })}
    </div>
  );
};
export default StoreMenuProduct;
